// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.wrapper-form[data-v-c36b12da] {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1rem/* 16px */;\n  padding-top: 0.5rem/* 8px */;\n  padding-bottom: 0.5rem/* 8px */;\n}\n", ""]);
// Exports
module.exports = exports;
